export default [
    {
        id: 'operatingRevenues',
        name: '營業收入',
        type: 1,
        children: [],
        amount: 0,
        percentage: 0,
        dC_TYP: 2,
        level: 0,
    },
    {
        id: 'netIncomeTotal',
        name: '營業收入淨額',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        isTotal: true,
        sumBy: ['operatingRevenues'],
        level: 0,
    },
    {
        id: 'costofGoodsSold',
        name: '銷貨成本',
        type: 1,
        children: [],
        amount: 0,
        percentage: 0,
        dC_TYP: 1,
        level: 0,
    },
    {
        id: 'manufacturingCosts',
        name: '製造成本',
        type: -1,
        children: [],
        amount: 0,
        percentage: 0,
        dC_TYP: 1,
        level: 0,
    },
    {
        id: 'otherOperatingExpenses',
        name: '其他營業成本',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        dC_TYP: 1,
        level: 0,
    },
    {
        id: 'costTotal',
        name: '營業成本',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        isTotal: true,
        sumBy: ['costofGoodsSold', 'manufacturingCosts', 'otherOperatingExpenses'],
        level: 0,
    },
    {
        id: 'profit',
        name: '營業毛利',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        isCalculate: true,
        method: ['-', 'netIncomeTotal', 'costTotal'],
        level: 0,
    },
    {
        id: 'operatingCost',
        name: '營業費用',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        dC_TYP: 1,
        level: 0,
    },
    {
        id: 'income',
        name: '營業收益',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        isCalculate: true,
        method: ['-', 'profit', 'operatingCost'],
        level: 0,
    },
    {
        id: 'nonOperatingIncome',
        name: '營業外收入',
        type: -1,
        children: [],
        amount: 0,
        percentage: 0,
        dC_TYP: 2,
        level: 0,
    },
    {
        id: 'nonOperatingExpenses',
        name: '營業外支出',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        dC_TYP: 1,
        level: 0,
    },
    {
        id: 'nonOperatingNetIncome',
        name: '營業外收入及支出總計',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        isCalculate: true,
        method: ['-', 'nonOperatingIncome', 'nonOperatingExpenses'],
        level: 0,
    },
    {
        id: 'NetProfitOrLoss',
        name: '稅前損益',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        isCalculate: true,
        method: ['+', 'income', 'nonOperatingNetIncome'],
        level: 0,
    },
    {
        id: 'incomeTax',
        name: '營利事業所得稅',
        type: 1,
        children: [],
        amount: 0,
        percentage: 0,
        dC_TYP: 1,
        level: 0,
    },
    {
        id: 'taxedProfitOrLoss',
        name: '稅後淨利',
        type: 0,
        children: [],
        amount: 0,
        percentage: 0,
        isCalculate: true,
        method: ['-', 'NetProfitOrLoss', 'incomeTax'],
        level: 0,
    },
];
